import React from 'react';
import Icon from '../../../components/AppIcon';

const ProcessingStats = ({ stats }) => {
  const statItems = [
    {
      label: 'Total Processed',
      value: stats?.totalProcessed || 0,
      icon: 'FileText',
      color: 'text-foreground',
      bgColor: 'bg-muted'
    },
    {
      label: 'In Queue',
      value: stats?.inQueue || 0,
      icon: 'Clock',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      label: 'Processing',
      value: stats?.processing || 0,
      icon: 'Loader',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      animate: 'animate-spin'
    },
    {
      label: 'Completed',
      value: stats?.completed || 0,
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Failed',
      value: stats?.failed || 0,
      icon: 'AlertCircle',
      color: 'text-error',
      bgColor: 'bg-error/10'
    },
    {
      label: 'Avg Score',
      value: stats?.averageScore ? `${stats?.averageScore}/100` : '0/100',
      icon: 'Brain',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10'
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-8">
      {statItems?.map((item, index) => (
        <div 
          key={index}
          className="bg-card border border-border rounded-lg p-4 card-elevation-base hover:card-elevation-hover transition-all duration-200"
        >
          <div className="flex items-center justify-between mb-3">
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${item?.bgColor}`}>
              <Icon 
                name={item?.icon} 
                size={20} 
                className={`${item?.color} ${item?.animate || ''}`}
              />
            </div>
          </div>
          
          <div>
            <div className={`text-2xl font-bold ${item?.color} mb-1`}>
              {item?.value}
            </div>
            <div className="text-sm text-muted-foreground">
              {item?.label}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProcessingStats;